// @flow
// @jsx h
import Vue from 'vue'
import Notifications from 'app/components/notifications/notifications.vue'
import store from 'app/store'

export const NotificationsView = new Vue({
    store,
    render(h) {
        return <Notifications/>
    }
})

